import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AuctionRow from './AuctionRow';
import { auctionPropertiesType, auctionsType, sortingParamType } from '../../types';
import './_styles_/AuctionsList.css';
import SortControl from '../SortControl';

AuctionsList.propTypes = {
    auctions: auctionsType.isRequired,
    auctionProps: auctionPropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
    activeProductType: PropTypes.string,
};

function AuctionsList(props) {
    const {
        auctions,
        auctionProps,
        onSort,
        sortingParam,
        activeProductType = null,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auctions-list">
            <div className="rich-list-row rich-list-header auctions-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="auction-header--main" />
                <div className="auction-header--id">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="id">
                        {t('auctions.list-header.id')}
                    </SortControl>
                </div>
                <div className="auction-header--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('auctions.list-header.name')}
                    </SortControl>
                </div>
                <div className="auction-header--product">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="product.productId">
                        {t('auctions.list-header.product')}
                    </SortControl>
                </div>
                {activeProductType === 'ALL' && (
                    <div className="auction-header--product-type">
                        <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="product.productType">
                            {t('auctions.list-header.product-type')}
                        </SortControl>
                    </div>
                )}
                {activeProductType === 'ENERGY' && (
                    <>
                        <div className="auction-header--number-of-lots">
                            <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="quantity">
                                {t('auctions.list-header.number-of-lots')}
                            </SortControl>
                        </div>
                        <div className="auction-header--energy-per-lot">
                            <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="energyPerLot">
                                {t('auctions.list-header.energy-per-lot')}
                            </SortControl>
                        </div>
                    </>
                )}
                {activeProductType === 'SECURITY' && (
                    <>
                        <div className="auction-header--scope">
                            <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="scope">
                                {t('auctions.list-header.scope')}
                            </SortControl>
                        </div>
                        <div className="auction-header--quantity">
                            <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="quantity">
                                {t('auctions.list-header.quantity')}
                            </SortControl>
                        </div>
                    </>
                )}
                <div className="auction-header--date">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="openingTime">
                        {t('auctions.list-header.date')}
                    </SortControl>
                </div>
                <div className="auction-header--progress">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="openingTime">
                        {t('auctions.list-header.progress')}
                    </SortControl>
                </div>
                <div className="auction-header--phase">
                    <span className="auction-header--phase--content">
                        <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="phase">
                            {t('auctions.list-header.phase')}
                        </SortControl>
                    </span>
                </div>
                <div className="auction-header--arrow" />
            </div>
            {
                auctions.length
                    ? auctions.map((auction) => (
                        <AuctionRow
                            key={auction.id}
                            auction={auction}
                            auctionProps={auctionProps}
                            activeProductType={activeProductType}
                        />
                    ))
                    : (<div className="auctions-no-items">{t('auctions.no-items')}</div>)
            }
        </div>
    );
}

export default AuctionsList;
